import { styled } from 'src/styles/stitches.config'

export const StyledBookingFormText = styled('div', {})

export const StyledColumn = styled('div', {
    '@md': {
        width: '50%',
    },
})
